<template lang="pug">
  .counter-widget
    header.header
      .level
        .level-left
          .title.is-4
            span.icon.is-medium
              i.fas.fa-calculator
            span Last subscriptions
        .level-right
          .title.tags.has-addons
            span.tag.has-text-weight-bold.is-black {{ total }}
    .columns.data-list.is-mobile.is-multiline.is-gapless
      .column.is-full
        .card(v-for="(subscription, i) in subscriptions" :key="subscription.createdAt")
          .card-content(:style="{ 'background-color': subscription.subscription ? subscription.subscription.color : '' }")
            .media
              .media-left
                figure.image.is-48x48
                  span.icon.is-large(:class="{ 'has-text-white': isActive(subscription) }")
                    i.fas.fa-money-check-alt.fa-2x
              .media-content
                .title.is-4.level
                  .level-left {{ getName(subscription) }}
                  .level-rigth.is-size-7 {{ subscription.user.email }}
                .subtitle.is-6 {{ dateFormat(subscription.createdOn) }} - {{ dateFormat(subscription.endedAt) }}
</template>

<script>
import moment from "moment";

export default {
  name: "SubscriptionsWidget",
  props: ["subscriptions", "total"],
  methods: {
    dateFormat(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    isActive(s) {
      if (!s || !s._id) return false;
      return (
        new Date() > new Date(s.createdOn) && new Date() < new Date(s.endedAt)
      );
    },
    getName(s) {
      if (!s || !s.subscription) return "";
      const name = s.subscription.name.replace(/_/g, " ");
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.counter-widget {
  position: relative;
  display: block;
  width: 100%;
  background: linear-gradient(180deg, #0bab64 0%, #3bb78f 100%);
  border-radius: 5px;

  .opacity {
    opacity: 0.8;
  }

  .header {
    position: relative;
    padding-bottom: 0.3rem;
    overflow: hidden;
    .level {
      padding: 1rem;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $defaultColor;

        .icon {
          margin-right: 0.5rem;
        }
      }
    }
  }

  .data-list {
    .container {
      padding: 0.5rem;
    }

    .card {
      box-shadow: none;
      background-color: rgba(0, 0, 0, 0.05);
      &:nth-child(odd) {
        background-color: rgba(0, 0, 0, 0.1);
      }
      .card-content {
        padding: 0.3rem 1rem;
        box-shadow: none;
      }
    }
  }
}
</style>
